// importando estilização do componente
import { useState } from 'react'
import { Styled } from './Styled';
import icons from '../../img/icons/icons';
import { CertificadosServices, ILead } from '../../shared/Services/api/certificados/Certificados.services';
import { useModal } from '../../shared/Contexts/Modal.context';
import { Desconto } from './Desconto/Desconto';

export const AlunoAprendiz: React.FC = () => {
    const [codigo, setCodigo] = useState("");
    const [showCertificado, setShowCertificado] = useState(false);
    const [lead, setLead] = useState<ILead | null>(null);
    const { openModal, closeModal } = useModal();

    const handleSearch = async () => {
        const searchLead = await CertificadosServices.getLeadByCodigo(codigo);
        if (searchLead instanceof Error) {
            alert(searchLead.message);
        } else {
            setLead(searchLead);
            openModal(<Desconto desconto={searchLead.desconto} onClose={closeModal} />);
        }   
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <>
            <Styled.Wrapper>
                <Styled.BackgroundVideo
                    src={require('../../img/Video.mp4')}
                    autoPlay
                    loop
                    muted
                    playsInline
                />
                <Styled.Overlay />
                <Styled.HomeIcon src={icons.home} alt="Home" onClick={() => window.location.href = '/'} />
                <Styled.CenterBox>
                    <Styled.Card>
                        <Styled.CertificadoIcon src={icons.AlunoAprendiz} alt="Certificado Premium" />
                        <Styled.InputBox>
                            <Styled.Input
                                type="text"
                                placeholder="Insira o código do seu certificado para consultar"
                                value={codigo}
                                onChange={e => setCodigo(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                            <Styled.SearchButton onClick={handleSearch}>
                                <Styled.SearchIcon src={icons.SearchWhite} alt="Buscar" />
                            </Styled.SearchButton>
                        </Styled.InputBox>
                    </Styled.Card>
                </Styled.CenterBox>
            </Styled.Wrapper>
            
        </>
    )
}
// aqui estamos exportando nosso componente
